module.exports = __webpack_public_path__ + "img/value-beinnovative.b222f5fe.svg";